import styled from 'styled-components'

const FilterItemGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 8px;
`

export default FilterItemGrid
